import React from "react";
import { motion } from "framer-motion";

export const About = () => {
  return (
    <section
      id="about"
      className="relative py-24 md:py-32 bg-[#2C3E35] text-[#FAF9F6] grain"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start"
        >
          <div className="lg:col-span-5">
            <div className="text-xs tracking-[0.24em] uppercase text-[#D5DCD5]/70 mb-6">
              About SentivoTech
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-balance">
              From reactive care
              <span className="italic text-[#E2A78E]"> to proactive </span>
              wellness intelligence.
            </h2>
          </div>

          <div className="lg:col-span-7 lg:pt-4">
            <p className="text-lg md:text-xl leading-relaxed text-[#E6EBE6]/90">
              We design context‑aware AI that quietly understands homes, habits and
              human needs — combining computer vision, behavioural intelligence and
              conversational interfaces to keep people safe, independent and
              connected.
            </p>
            <div className="hairline my-10 opacity-30" />
            <div className="grid sm:grid-cols-3 gap-8">
              {[
                {
                  t: "Empowering families",
                  d: "Real‑time insights and peace of mind, while respecting independence.",
                },
                {
                  t: "Supporting caregivers",
                  d: "Intelligent tools to deliver more personalised, effective care.",
                },
                {
                  t: "Building communities",
                  d: "Connecting seniors, families and providers into supportive networks.",
                },
              ].map((p) => (
                <div key={p.t}>
                  <div className="font-serif text-xl text-white mb-2">{p.t}</div>
                  <p className="text-sm text-[#D5DCD5]/80 leading-relaxed">{p.d}</p>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
